import React from "react"

export const SearchBar = () => <h1>New Search Bar</h1>
